export const WHITE = '#FFFFFF'
export const GREEN = '#50B848'
export const YELLOW = '#FFF200'
export const ORANGE = '#F7941E'
export const RED = '#ED1C24'
export const BLACK = '#231F20'
export const BLUE = '#0072C6'
